import React from 'react';

interface Nl2BrProps {
  text: string;
  maxConsecutiveBlankLines?: number;
  ignoreTrailingBlankLines?: boolean;
}

export default function Nl2Br({
  text,
  maxConsecutiveBlankLines = 1,
  ignoreTrailingBlankLines = true,
}: Nl2BrProps) {
  // Split text into lines
  const lines = text.split(/\r\n|\r|\n/);

  // Process consecutive blank lines if needed
  let processedLines = lines;

  if (maxConsecutiveBlankLines !== undefined) {
    processedLines = [];
    let blankLineCount = 0;

    for (const line of lines) {
      if (line.trim() === '') {
        blankLineCount++;
        if (blankLineCount <= maxConsecutiveBlankLines) {
          processedLines.push(line);
        }
      } else {
        processedLines.push(line);
        blankLineCount = 0;
      }
    }
  }

  // Remove trailing blank lines if needed
  if (ignoreTrailingBlankLines) {
    while (
      processedLines.length > 0 &&
      processedLines[processedLines.length - 1].trim() === ''
    ) {
      processedLines.pop();
    }
  }

  return (
    <>
      {processedLines.map((line, index) => (
        <React.Fragment key={index}>
          {line}
          {index < processedLines.length - 1 && <br />}
        </React.Fragment>
      ))}
    </>
  );
}
